import { Point } from 'generated/leaderboard-client';

import { TableWidgetPoint } from './points';

function getPointValue(point: Point): number {
  const mean =
    point.bucket && point.bucket.count ? point.bucket.sum / point.bucket.count : undefined;

  return mean ?? point.y ?? NaN;
}

function convertTableWidgetPointFromApiToDomain(point: Point): TableWidgetPoint {
  return [point.x, getPointValue(point), undefined, undefined, point.interpolation];
}

export function convertTableWidgetSeriesPointsFromApiToDomain(
  values: Array<Point>,
): TableWidgetPoint[] {
  return values.map((point) => convertTableWidgetPointFromApiToDomain(point));
}
